import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { colors, MultipleChoiceSelectionModal } from 'z-react-components';

export default class LeavePageConfirmationModal extends Component {
    constructor() {
        super();
        this.state = { visible: true };
    }

    static propTypes = {
        message: PropTypes.shape({
            content: PropTypes.string,
            remainButtonMessage: PropTypes.string
        }),
        onClick: PropTypes.func.isRequired
    };

    static defaultProps = {
        message: {}
    };

    componentWillReceiveProps() {
        // the next line is to ensure that after the component is closed it is
        // enabled for another shown
        this.setState({ visible: true });
    }

    render() {
        const {
            message: { content, remainButtonMessage },
            onClick
        } = this.props;
        const { visible } = this.state;
        return (
            <MultipleChoiceSelectionModal
                choices={[
                    {
                        content: remainButtonMessage,
                        onSelection: () => {
                            this.setState({ visible: false });
                            onClick(false);
                        },
                        style: {
                            border: 'none',
                            textTransform: 'uppercase',
                            backgroundColor: colors.grey500,
                            color: colors.white
                        }
                    },
                    {
                        content: 'Continua',
                        onSelection: () => {
                            this.setState({ visible: false });
                            onClick(true);
                        },
                        style: {
                            border: 'none',
                            textTransform: 'uppercase',
                            backgroundColor: colors.orange,
                            color: colors.white
                        }
                    }
                ]}
                content={content}
                open={visible}
                showCloseButton={true}
                onCancel={() => {
                    this.setState({ visible: false });
                    onClick(false);
                }}
            />
        );
    }
}
